import { useMemo } from "react";

export function useStaticOptions({ options, textGetter, sortOptions, endPoint }) {
  return useMemo(() => {
    if (!options || endPoint) {
      return [];
    }

    const result = (Array.isArray(options) ? options.slice(0) : Object.values(options));

    if (sortOptions) {
      result.sort((a, b) => {
        const nameA = textGetter(a)?.toLowerCase() ?? '';
        const nameB = textGetter(b)?.toLowerCase() ?? '';
        return nameA.localeCompare(nameB);
      });
    }

    const load = async (search) => {
      const options = search ? result.filter((option) => textGetter(option)?.toLowerCase().includes(search.toLowerCase())) : result;

      return { options, hasMore: false };
    };

    return [result, load] as const;
  }, [options, textGetter, sortOptions, endPoint]);
}
